import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { statusValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import TabPanel from "../Reusable/Tab";
import ReceiverStatusForm from "./ReceiverStatusForm";
import SenderStatusForm from "./SenderStatusForm";
import StatusForm from "./StatusForm";
const EditStatus = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(statusValidationForm),
    defaultValues: async () => {
      let data: any = await props?.handleLazyFetch();
      return {
        ...data.data,
      };
    },
  });
  const { handleEdit, statusList, isLoading } = props;
  return (
    <TabPanel
      tabTitle={[
        "Edit Status",
        "Edit Receiver Email/SMS Content",
        "Edit Sender Email/SMS Content",
      ]}
      tabPanels={[
        <div>
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
          >
            <StatusForm
              errors={errors}
              clearErrors={clearErrors}
              register={register}
              statusList={statusList}
              setValue={setValue}
              getValues={getValues}
              control={control}
              watch={watch}
            />
          </FormLayout>
        </div>,
        <div>
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
          >
            <ReceiverStatusForm
              errors={errors}
              clearErrors={clearErrors}
              register={register}
              statusList={statusList}
              setValue={setValue}
              getValues={getValues}
              control={control}
              watch={watch}
            />
          </FormLayout>
        </div>,
        <div>
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
          >
            <SenderStatusForm
              errors={errors}
              clearErrors={clearErrors}
              register={register}
              statusList={statusList}
              setValue={setValue}
              getValues={getValues}
              control={control}
              watch={watch}
            />
          </FormLayout>
        </div>,
      ]}
    />
  );
};

export default EditStatus;
